import React, { useState } from "react";
import { Checkbox, Col, Flex, Typography, Pagination } from "antd";
import { Userprofile } from "../../../Interface/Index";
import "./CVList.scss";
import { getFileMimeTypeImage } from "../../../Utils/generic-functions";
import useMediaQuery from "../../../Hooks/useMediaQuery";

interface CVListProps {
  file?: File | null;
  handleChange: (profile: Userprofile | null) => void;
  savedProfile: Userprofile[];
}

const CVList: React.FC<CVListProps> = ({
  file,
  handleChange,
  savedProfile,
}) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const itemsPerPage = 2;

  const isMobileScreen = useMediaQuery("(max-width: 768px)");

  const onChange = (item: Userprofile) => {
    if (selectedId === item._id) {
      setSelectedId(null);
      handleChange(null);
    } else {
      setSelectedId(item._id);
      handleChange(item);
    }
  };

  const paginatedProfiles = savedProfile.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <Typography.Title level={5} type="secondary">
        Continue with previously uploaded CV
      </Typography.Title>
      {paginatedProfiles.length > 0 &&
        paginatedProfiles.map((item: Userprofile, index: number) => (
          <Flex
            justify="center"
            key={index}
            className={`checkbox_container ${
              selectedId === item._id ? "clicked" : ""
            } ${file ? "disabled" : ""}`}
            align="center"
            onClick={() => !file && onChange(item)}
          >
            <Col>
              <Checkbox
                checked={selectedId === item._id}
                onChange={() => !file && onChange(item)}
                disabled={!!file}
                style={{ margin: "0 8px" }}
              />
            </Col>
            <Col className="svg_container">
              <img
                src={getFileMimeTypeImage(item.filename)}
                alt="resume_file_logo"
                className="svg-icon"
                style={{ margin: "8px" }}
              />
            </Col>
            <Col className="resume_info">
              <Typography.Text style={{ margin: "0 4px" }}>
                {item.filename}
              </Typography.Text>
            </Col>
            <Col flex="auto"></Col>
          </Flex>
        ))}
      <Flex justify="flex-end">
        <div className="cv_list_pagination">
          <Pagination
            simple={isMobileScreen}
            showSizeChanger={false}
            defaultCurrent={currentPage}
            current={currentPage}
            total={savedProfile.length}
            pageSize={itemsPerPage}
            onChange={(page) => setCurrentPage(page)}
            style={{ textAlign: "center" }}
          />
        </div>
      </Flex>
    </>
  );
};

export default CVList;
